import React, { useEffect, useState } from 'react'
import ReactHtmlParser from 'react-html-parser'; 


import { getSizedImageUrl } from '../../../../../scripts/utils/image'

import { useSubBuilder } from '../../../../context/subBuilder/useSubBuilder'
import { findKgVariantOnProduct } from '../../../../context/subBuilder/utils'
import { ProductVariant } from '../../../../util/typings';
import Price from '../../../Price'
import Calculator from '../components/Calculator';
import GreyBoxYellowBoxSwitcheroo from '../components/GreyBoxYellowBoxSwitcheroo'

import SubBuilderStep from '../components/SubBuilderStep'
import BackgroundBlackOutline from '../svgs/BlackOutline'
import IconInfoYellow from '../svgs/InfoYellow'

const Quantity: React.FunctionComponent = () => {
  const { settings, state, actions, getters } = useSubBuilder()
  const [variant, setProductVariant] = useState<ProductVariant>(null)
  
  useEffect(() => {
    const vnt = state.subscriptionType === 'me' ? getters.getCurrentVariant() : getters.getCurrentGiftVariant()
    if (vnt) {
      setProductVariant(vnt)
    }
  }, [state] )

  const [calculatorOpen, setCalculatorOpen] = useState(false)
  useEffect(() => {
    document.body.classList.toggle('overflow-hidden', calculatorOpen)
  }, [calculatorOpen])

  const typeOfOptions = state.isBothProducts ? 'two_x_quantity_option' : 'quantity_option';
  const quantityOptions = settings.steps.quantity.options.filter(({ type }) => type === typeOfOptions);
  if (!quantityOptions || quantityOptions.length < 1) {
    console.error(`No quantity options set, please make sure you add block of type ${typeOfOptions} in the settings.`)
  }
  return (
    <>
      {variant && <SubBuilderStep className="sub-builder-quantity" index={5} stepConfig={settings.steps.quantity}>
        <div className="sub-builder-quantity-label-calc">
          <label className="sub-builder-quantity-label">{settings.steps.quantity.strings.label}</label>
          <div>
            <label className="sub-builder-quantity-calc-label">{ settings.steps.quantity.strings.calculatorLabel }</label>
            <button onClick={() => setCalculatorOpen(true)} className="sub-builder-quantity-calc-cta">{ settings.steps.quantity.strings.calculatorCta }</button>
          </div>
        </div>
        <div className="sub-builder-quantity-options">
          
          {quantityOptions.map((option, i) => {
            const { image, quantity, title } = option;
            const giftProduct = settings.products.gift.find(
              p => state.productHandles?.includes(p.product.handle)
            )?.product || null;
            const kgVar = (giftProduct && quantity % 4 === 0) ? findKgVariantOnProduct(giftProduct, state.giftGrindOption) : null;
            const finalPrice = kgVar ? kgVar.price * (quantity / 4) : variant.price * quantity;
            return (
              <button className="sub-builder-btn-quantity sub-builder-btn" id={`sub-builder-btn-quantity-${i}`} key={quantity} type="button" onClick={() => {
                actions.setQuantityOption(quantity)
                actions.moveStep(+1)
              }}>
                <GreyBoxYellowBoxSwitcheroo className="sub-builder-btn-img sub-builder-quantity-img">
                  <img src={getSizedImageUrl(image, '300x300') || image} data-lazy-load />
                </GreyBoxYellowBoxSwitcheroo>
                <h3 className="sub-builder-btn-title">{ title }</h3>
                <Price
                  finalPrice={finalPrice}
                  originalPrice={finalPrice}
                  priceVaries={false}
                />
              </button>
            )
          })}
        </div>
        <div className="sub-builder-info-box relative flex align-center">
          <BackgroundBlackOutline />
          <IconInfoYellow className="icon-info-box" />
          { ReactHtmlParser(settings.steps.quantity.strings.infoText) }
        </div>
      </SubBuilderStep>}
      { calculatorOpen && <Calculator open={calculatorOpen} onClose={() => setCalculatorOpen(false)} /> } 
    </>
  )

    

}
export default Quantity
